// // Display in new tab
// var links = document.links;
// for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//   if (links[i].hostname !== window.location.hostname) {
//     links[i].target = '_blank';
//     links[i].rel = 'noreferrer noopener';
//   }
// }


// var newWindowWidth = $(window).width();
// if (newWindowWidth < 750) {
// // Footer Accordion
// $(".footer-block__heading").click(function () {
//    if ($(".footer-block__details-content").is(':visible')) {
//       $(".footer-block__details-content").slideUp(500);
//       $(".down").show();
//       $(".up").hide();
//     }
//    if ($(this).next(".footer-block__details-content").is(':visible')) {
//         $(this).next(".footer-block__details-content").slideUp(500);
//         $(this).find(".down").show();
//         $(this).find(".up").hide();
//     } else {
//         $(this).next(".footer-block__details-content").slideDown(500);
//         $(this).find(".up").show();
//         $(this).find(".down").hide();
//     }
// });
// }  

// // multicolumn - accordion
// $(".abz_multicolumn_1 .ml_sec_title").click(function () {
//    if ($(".abz_multicolumn_1 .multi_text").is(':visible')) {
//       $(".abz_multicolumn_1 .multi_text").slideUp(500);
//       $(".down1").show();
//       $(".up1").hide();
//     }
//    if ($(this).next(".abz_multicolumn_1 .multi_text").is(':visible')) {
//         $(this).next(".abz_multicolumn_1 .multi_text").slideUp(500);
//         $(this).find(".down1").show();
//         $(this).find(".up1").hide();
//     } else {
//         $(this).next(".abz_multicolumn_1 .multi_text").slideDown(500);
//         $(this).find(".up1").show();
//         $(this).find(".down1").hide();
//     }
// });


// /* Grid Slider */
// $(document).ready(function() {
//     $('.main-carousel').flickity({
//         cellAlign: 'left',
//         contain: true
//     }); 
// });

// document.querySelectorAll('.slide_grid_nav button').forEach(btn => {
//     let anchor = btn.parentElement.parentElement.querySelector('.grid_slider_title');
//     btn.addEventListener("click", function() {
//         if(btn.hasAttribute('active')) return;
//         const slideGrid = btn.parentElement.parentElement.querySelector('.slide_grid');
//         if(!slideGrid) return;
        
//         if(!anchor) anchor = slideGrid;
//         anchor.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });

//         setTimeout(() => {
//             slideGrid.dataset.page = btn.dataset.page;
//             window.dispatchEvent(new Event('resize')); 
//         }, 1000);
//         setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 2000);
        
//         let activeBtn = document.querySelector('.slide_grid_nav button[active]');
//         activeBtn.removeAttribute('active');
//         btn.setAttribute('active', ''); 

//     })
// });

(function () {
  "use strict";

  // Display external links in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Run jQuery-based code only if jQuery is loaded
    if (window.jQuery) {
      const $ = window.jQuery;

      var newWindowWidth = $(window).width();

      if (newWindowWidth < 750) {
        // Footer Accordion
        $(".footer-block__heading").on("click", function () {
          if ($(".footer-block__details-content").is(":visible")) {
            $(".footer-block__details-content").slideUp(500);
            $(".down").show();
            $(".up").hide();
          }

          if ($(this).next(".footer-block__details-content").is(":visible")) {
            $(this).next(".footer-block__details-content").slideUp(500);
            $(this).find(".down").show();
            $(this).find(".up").hide();
          } else {
            $(this).next(".footer-block__details-content").slideDown(500);
            $(this).find(".up").show();
            $(this).find(".down").hide();
          }
        });
      }

      // multicolumn - accordion
      $(".abz_multicolumn_1 .ml_sec_title").on("click", function () {
        if ($(".abz_multicolumn_1 .multi_text").is(":visible")) {
          $(".abz_multicolumn_1 .multi_text").slideUp(500);
          $(".down1").show();
          $(".up1").hide();
        }

        if ($(this).next(".multi_text").is(":visible")) {
          $(this).next(".multi_text").slideUp(500);
          $(this).find(".down1").show();
          $(this).find(".up1").hide();
        } else {
          $(this).next(".multi_text").slideDown(500);
          $(this).find(".up1").show();
          $(this).find(".down1").hide();
        }
      });

      // Grid Slider
      if ($.fn.flickity) {
        $(".main-carousel").flickity({
          cellAlign: "left",
          contain: true
        });
      } else {
        console.warn("Flickity is not loaded.");
      }
    } else {
      console.warn("jQuery is not loaded. abz_designer.js jQuery features were skipped.");
    }

    // Non-jQuery nav button logic
    document.querySelectorAll(".slide_grid_nav button").forEach((btn) => {
      let anchor = btn.parentElement.parentElement.querySelector(".grid_slider_title");

      btn.addEventListener("click", function () {
        if (btn.hasAttribute("active")) return;

        const slideGrid = btn.parentElement.parentElement.querySelector(".slide_grid");
        if (!slideGrid) return;

        if (!anchor) anchor = slideGrid;

        anchor.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });

        setTimeout(() => {
          slideGrid.dataset.page = btn.dataset.page;
          window.dispatchEvent(new Event("resize"));
        }, 1000);

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 2000);

        let activeBtn = btn.parentElement.querySelector("button[active]");
        if (activeBtn) {
          activeBtn.removeAttribute("active");
        }

        btn.setAttribute("active", "");
      });
    });
  });
})();

document.fonts.ready.then(function () {
  document.documentElement.classList.add("fonts-loaded");
});